<div class="container container-fixed mt-4">
  <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
  <div *ngIf="!isLoading">
    <h1 class="c-form__titulo h1-montserrat">¡Bienvenido al portal!</h1>
    <span class="c-form__titulo h1-montserrat">{{ displayName }}</span>
    <hr />
    <div class="row" style="display: flex; flex-wrap: wrap">
      <ng-container *ngFor="let cardItem of cardsList">
        <ng-container *ngIf="showCardItem(cardItem)">
          <div class="col-md-4" style="display: flex">
            <div class="card" style="flex: 1">
              <div class="card-top">
                <div class="card-top-text">
                  <h2>{{ cardItem.title }}</h2>
                </div>
              </div>
              <div class="card-body">
                <h2 class="card-title">Información</h2>
                <p class="card-body-text">
                  {{ cardItem.body }}
                </p>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
